import { networkClient } from '@network/networkClient'
import { getGlobalParams } from '../globalParams'
import { GET_BUY_BONUS_PACKAGES, BUY_BONUS_PACKAGE } from '../queries/buyBonusQueries'
import { logger } from '@logger'

const MODULE = 'Buy Bonus Service'

// Available buy-bonus packages for the brand. All args are globals from session.
export const getBuyBonusPackages = async () => {
  const { operatorId, brandId, currency, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_BUY_BONUS_PACKAGES,
      variables: { operatorId, brandId, currency, gameCode },
    },
  })

  logger.info(MODULE, 'getBuyBonusPackages Response', response)

  if (response.players.getBuyBonusPackages.success) {
    return response.players.getBuyBonusPackages.data
  } else {
    throw new Error(
      response.players.getBuyBonusPackages.message || 'Failed to fetch buy-bonus packages'
    )
  }
}

// Purchase a package (mutation). Component passes only { packageValue, packageId }.
// Awarded freebets then surface via fetchFreebets.
export const buyBonusPackage = async ({ packageValue, packageId } = {}) => {
  const { playerId, token, operatorId, brandId, currency, gameCode, gameMode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: BUY_BONUS_PACKAGE,
      variables: {
        playerId,
        token,
        operatorId,
        brandId,
        currency,
        gameCode,
        packageValue,
        packageId,
        gameMode,
      },
    },
  })

  logger.info(MODULE, 'buyBonusPackage Response', response)

  if (response.players.buyBonusPackage.success) {
    return response.players.buyBonusPackage.data
  } else {
    throw new Error(response.players.buyBonusPackage.message || 'Failed to buy bonus package')
  }
}
